<template>
  <div :class="{feedback:true, scrollTop:scrollTop}" style="display: flex;flex-direction: column;">
    <!-- <a href="https://login.hbgyl.com.cn/login?appId=77a40024-5dee-41ac-8b51-d8ed98f14093&redirect_uri=https://llmapi.hbgyl.com.cn/social-callback?source=user_center&grantType=social&response_type=code" target="_blank" class="feedback-btn"> 
      <img class="imgOne" src="../../assets/icon/damoxingAi.png" alt="">
    </a> -->
    <a href="https://user-railway.hbgyl.com.cn/Home/Railway" target="_blank" class="feedback-btn"> 
      <img class="imgOne" src="../../assets/icon/zhongoujingjia.png" alt="">
    </a>
  
    <!-- <div class="item" v-for="(item, i) in data"  :key="i">
      <img :src="require('../../assets/icon/'+ item.icon +'.png')" alt="">
      <div class="icon-title">{{item.name}}</div>
      <div class="faq">
          <img :src="require('../../assets/images/publiccode.jpg')" style="width: 100px;height:100px;">
          <div class="infor-style">
            <div class="title-style">微信扫码</div>
            <div class="sbtitle-style">联系公众号客服</div>
          </div>
      </div> -->

<!--      <p v-if="!isShrink">{{item.name}}</p>-->
<!--      <p v-else>展开</p>-->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'feedback',
  data () {
    return {
      data: [],
      dataOff: [
        // {name: '帮助中心', icon:'faq_wen', method: 'help', path:'/helpCenter'},
        {name: '咨询', icon:'faq_auto', method: 'consult'},
        // {name: '网站地图', icon:'faq_map', method: 'message', path:'/helpCenter'},
        // {name: '返回顶部', icon:'faq_up', method: 'returntop'}
      ],
      dataOn: [
        {name: '收起', icon:'feedback_icon05', method: 'shrink'}
      ],
      scrollTop: false,
      isShrink: false
    }
  },

  mounted() {
    this.data = this.dataOff
    //window.addEventListener('scroll',this.getScroll)
  },

  methods: {
    // getScroll() {
    //   const top = document.documentElement.scrollTop || document.body.scrollTop
    //   this.scrollTop = top > 430;
    // },

    // @click="methodEvent(item.method, item)"
    // methodEvent(e, item) {
    //   eval(this[e])(item)
    // },

    // 帮助
    help(item) {
      console.log(item)
      this.$router.push({path: item.path,query:{tab:'first'}})
    },

    //返回顶部
    returntop() {
      const timer= setInterval(function () {
        if (document.documentElement.scrollTop !== 0) {
          document.documentElement.scrollTop -= 100;
        } else {
          clearInterval(timer);
        }
      }, 10);
    },

    // 网站地图
    message(item) {
      this.$router.push({path: item.path,query:{tab:'map'}})
    },

    // 咨询
    consult() {

    },

    // 收起
    shrink() {
      this.isShrink = !this.isShrink

      if(this.isShrink) {
        this.data = this.dataOn
      } else {
        this.data = this.dataOff
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .feedback {
    z-index: 1000;
    position: fixed;
    right: 10px;
    bottom: 40%;
    text-align: center;

  }
  .scrollTop {
    position:fixed;
    top: 20%;
    right: 10px;
  }
  .feedback .item {
    position: relative;
    cursor: pointer;
    /* margin-top: -10px; */
    background-color: #0256FF;
    padding: 5px 14px 4px;
    box-shadow: -3px 2px 3px 0 rgba(0, 0, 0, 0.4)
    
  }
  .feedback .imgOne {
    width: auto;
    height: 100px;
    margin-top: 1px;
  }
  .feedback .item img {
    width: 25px;
    height: 25px;
  }
  .feedback .item p {
    color: rgba(38, 37, 47, 0.5);
    font-size: 16px;
  }
  .icon-title{
    color: #fff;
    font-size: 12px;
  }
  .faq{
    display: none;
  }
  .feedback-btn:hover{
    opacity: 0.7;
  }
  .feedback .item:hover .faq {
    display: inline-flex;
    position: absolute;
    padding: 10px 14px 10px 10px;
    text-align: center;
    /* width: 130px;
    height: 70px;
    line-height: 65px; */
    font-weight: 500;
    /* margin-left: -175px; */
    color: #3D3D3D;
    font-size: 14px;
    top: 0px;
    right: 112%;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, 0.4)

  }
  .infor-style{
    margin-left: 10px;
    margin-top: 6px;
      white-space: nowrap;
  }
  .title-style{
    font-weight: 600;
  text-align: left;
    color: #3D3D3D;
    
  }
  .sbtitle-style{
   margin-top: 6px;
   font-size: 13px;
    color: rgb(179 179 179);
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/feedback.vue